import { repositoryPos } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import type { MessageResponse } from "../../../../model/MessageResponse";
import type { SaleKindConfig } from "../config/saleKinds";

/**
 * Việc sau khi khoá phiếu ở trang xuất bán mới.
 *
 * Tạo đơn vận chuyển (GHTK / Ahamove / Grab theo đơn vị giao của đơn) và gửi ZNS báo xuất kho không còn chạy trên
 * trình duyệt: api-pos phát `SaleOrderDispatchedIntegrationEvent` sau khi khoá phiếu XUAT_BAN, hacom.consumer.delivery
 * (`Api/ShippingPartner`) xử lý nền, kết quả gửi vào thông báo của nhân viên khoá phiếu.
 *
 * File riêng của trang xuất bán mới, không dùng `shipping/afterLockTasks.ts` (code cũ, giữ nguyên).
 */

/** Báo người dùng sau khi khoá phiếu thành công */
export const notifyAfterLock = (kind: SaleKindConfig) => {
  NotificationExtension.Success("Khóa phiếu xuất kho thành công");
  if (kind.createShippingOrders || kind.sendZns) {
    NotificationExtension.Info(
      "Hệ thống đang tạo đơn vận chuyển và gửi ZNS cho đơn (nếu có), kết quả sẽ có trong thông báo.",
    );
  }
};

/** Chi nhánh dịch vụ (attr6 = "DVT") dùng QR tĩnh khi in phiếu */
export const isDvtBranch = async (branchId: number | null | undefined) => {
  const res = await repositoryPos.get<MessageResponse<any[]>>(
    "/api/v1/TblDmInventory/get-select-branch?auth=false",
  );
  return res?.data?.find((item: any) => Number(item.value) === Number(branchId))?.attr6 === "DVT";
};
